// removed by extract-text-webpack-plugin
module.exports = {"header":"ICR08Si8EQHzFmyuhjrAf","header__inner":"_26EbiZGl0Gp2f0rJaWnaCL","header__logo":"_14E2HLc9-Jdws4oSsWWDaW"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73659d1a","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./src/styles/SiteHeader.styl
// module id = 11
// module chunks = 0